
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
  isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);

  handleOpenPermission() {
    this.$emit("prevStep");
  }
}
